import presetListView from './PresetListView'
const presetSelect = {
  hasBuilderButton: true,
  hasNormsTab: true,
  presetListView
}

export default presetSelect
export { presetSelect }



// WEBPACK FOOTER //
// ./src/app/configuration/Template/config/components/selection/PresetSelect/index.js